var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, reaction, makeObservable } from 'mobx';
export class MenubarSpeak {
    parent;
    isMenubarSpeakIconHovered = false;
    isMenubarSpeakPopoverOpen = false;
    isMenubarSpeakPopoverHovered = false;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent.app;
    }
    get topic() {
        return this.app.solidTopic;
    }
    closer = reaction(() => this.isMenubarSpeakPopoverOpen && !this.isMenubarSpeakPopoverHovered && !this.isMenubarSpeakIconHovered, length => (this.isMenubarSpeakPopoverOpen = false), { delay: 700, fireImmediately: false, name: 'closeMenubarSpeakPopover' });
}
__decorate([
    observable
], MenubarSpeak.prototype, "isMenubarSpeakIconHovered", void 0);
__decorate([
    observable
], MenubarSpeak.prototype, "isMenubarSpeakPopoverOpen", void 0);
__decorate([
    observable
], MenubarSpeak.prototype, "isMenubarSpeakPopoverHovered", void 0);
